export default "__VITE_ASSET__1gr238Mj__"